/// <amd-module name="Search/WebApi/RestClient/Search" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   search\client\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Search from "Search/WebApi/Contracts/Search";
import * as Search_Shared_Contracts from "Search/WebApi/Contracts/Search.Shared";

export interface ISearchRestClient extends IVssRestClient {
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    fetchAdvancedCodeSearchResults(request: Search.CodeSearchRequest, project?: string): Promise<Search.CodeSearchResponse>;
    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Board Search Request.
     * @param project - Project ID or project name
     */
    fetchBoardSearchResults(request: Search.BoardSearchRequest, project: string): Promise<Search.BoardSearchResponse>;
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    fetchScrollCodeSearchResults(request: Search_Shared_Contracts.ScrollSearchRequest, project?: string): Promise<Search.CodeSearchResponse>;
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    fetchCodeSearchResults(request: Search.CodeSearchRequest, project?: string): Promise<Search.CodeSearchResponse>;
    /**
     * Provides status of Custom Repository.
     * 
     * @param project - Project ID or project name
     * @param repository - Repository ID or repository name for a custom repository.
     */
    getCustomRepositoryStatus(project: string, repository: string): Promise<Search.CustomRepositoryStatusResponse>;
    /**
     * Provides indexing status of custom repository branch
     * 
     * @param project - Project ID or project name
     * @param repository - 
     * @param branch - 
     */
    getCustomRepositoryBranchStatus(project: string, repository: string, branch: string): Promise<Search.CustomRepositoryBranchStatusResponse>;
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Package Search Request.
     */
    fetchPackageSearchResults(request: Search_Shared_Contracts.PackageSearchRequest): Promise<Search_Shared_Contracts.PackageSearchResponse>;
    /**
     * Provides status of Repository.
     * 
     * @param project - Project ID or project name
     * @param repository - Repository ID or repository name.
     */
    getRepositoryStatus(project: string, repository: string): Promise<Search.RepositoryStatusResponse>;
    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Setting Search Request.
     */
    fetchSettingSearchResults(request: Search_Shared_Contracts.SettingSearchRequest): Promise<Search_Shared_Contracts.SettingSearchResponse>;
    /**
     * Provides status of TFVC Repository.
     * 
     * @param project - Project ID or project name
     */
    getTfvcRepositoryStatus(project: string): Promise<Search.TfvcRepositoryStatusResponse>;
    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Wiki Search Request.
     * @param project - Project ID or project name
     */
    fetchWikiSearchResults(request: Search_Shared_Contracts.WikiSearchRequest, project?: string): Promise<Search_Shared_Contracts.WikiSearchResponse>;
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Work Item Search Request.
     * @param project - Project ID or project name
     */
    fetchWorkItemInstantSearchResults(request: Search.WorkItemSearchRequest, project?: string): Promise<Search.WorkItemSearchResponse>;
    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Work Item Search Request.
     * @param project - Project ID or project name
     */
    fetchWorkItemSearchResults(request: Search.WorkItemSearchRequest, project?: string): Promise<Search.WorkItemSearchResponse>;
}

class SearchRestClient extends RestClientBase implements ISearchRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    public async fetchAdvancedCodeSearchResults(
        request: Search.CodeSearchRequest,
        project?: string
        ): Promise<Search.CodeSearchResponse> {

        return this.beginRequest<Search.CodeSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/advancedCodeSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Board Search Request.
     * @param project - Project ID or project name
     */
    public async fetchBoardSearchResults(
        request: Search.BoardSearchRequest,
        project: string
        ): Promise<Search.BoardSearchResponse> {

        return this.beginRequest<Search.BoardSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/boardSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    public async fetchScrollCodeSearchResults(
        request: Search_Shared_Contracts.ScrollSearchRequest,
        project?: string
        ): Promise<Search.CodeSearchResponse> {

        return this.beginRequest<Search.CodeSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeSearchPaginatedResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Code Search Request.
     * @param project - Project ID or project name
     */
    public async fetchCodeSearchResults(
        request: Search.CodeSearchRequest,
        project?: string
        ): Promise<Search.CodeSearchResponse> {

        return this.beginRequest<Search.CodeSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides status of Custom Repository.
     * 
     * @param project - Project ID or project name
     * @param repository - Repository ID or repository name for a custom repository.
     */
    public async getCustomRepositoryStatus(
        project: string,
        repository: string
        ): Promise<Search.CustomRepositoryStatusResponse> {

        return this.beginRequest<Search.CustomRepositoryStatusResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/search/status/customRepositories/{repository}",
            routeValues: {
                project: project,
                repository: repository
            }
        });
    }

    /**
     * Provides indexing status of custom repository branch
     * 
     * @param project - Project ID or project name
     * @param repository - 
     * @param branch - 
     */
    public async getCustomRepositoryBranchStatus(
        project: string,
        repository: string,
        branch: string
        ): Promise<Search.CustomRepositoryBranchStatusResponse> {

        return this.beginRequest<Search.CustomRepositoryBranchStatusResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/search/customRepositoryBranch/{repository}/{branch}",
            routeValues: {
                project: project,
                repository: repository,
                branch: branch
            }
        });
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Package Search Request.
     */
    public async fetchPackageSearchResults(
        request: Search_Shared_Contracts.PackageSearchRequest
        ): Promise<Search_Shared_Contracts.PackageSearchResponse> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/search/packageSearchResults",
            body: request,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("ActivityId");
            const result: Search_Shared_Contracts.PackageSearchResponse = {
                content: <Search_Shared_Contracts.PackageSearchResponseContent>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Provides status of Repository.
     * 
     * @param project - Project ID or project name
     * @param repository - Repository ID or repository name.
     */
    public async getRepositoryStatus(
        project: string,
        repository: string
        ): Promise<Search.RepositoryStatusResponse> {

        return this.beginRequest<Search.RepositoryStatusResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/search/status/repositories/{repository}",
            routeValues: {
                project: project,
                repository: repository
            }
        });
    }

    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Setting Search Request.
     */
    public async fetchSettingSearchResults(
        request: Search_Shared_Contracts.SettingSearchRequest
        ): Promise<Search_Shared_Contracts.SettingSearchResponse> {

        return this.beginRequest<Search_Shared_Contracts.SettingSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/search/settingSearchResults",
            body: request
        });
    }

    /**
     * Provides status of TFVC Repository.
     * 
     * @param project - Project ID or project name
     */
    public async getTfvcRepositoryStatus(
        project: string
        ): Promise<Search.TfvcRepositoryStatusResponse> {

        return this.beginRequest<Search.TfvcRepositoryStatusResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/search/status/tfvc",
            routeValues: {
                project: project
            }
        });
    }

    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Wiki Search Request.
     * @param project - Project ID or project name
     */
    public async fetchWikiSearchResults(
        request: Search_Shared_Contracts.WikiSearchRequest,
        project?: string
        ): Promise<Search_Shared_Contracts.WikiSearchResponse> {

        return this.beginRequest<Search_Shared_Contracts.WikiSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/wikiSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Work Item Search Request.
     * @param project - Project ID or project name
     */
    public async fetchWorkItemInstantSearchResults(
        request: Search.WorkItemSearchRequest,
        project?: string
        ): Promise<Search.WorkItemSearchResponse> {

        return this.beginRequest<Search.WorkItemSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/workItemInstantSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

    /**
     * Provides a set of results for the search text.
     * 
     * @param request - The Work Item Search Request.
     * @param project - Project ID or project name
     */
    public async fetchWorkItemSearchResults(
        request: Search.WorkItemSearchRequest,
        project?: string
        ): Promise<Search.WorkItemSearchResponse> {

        return this.beginRequest<Search.WorkItemSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/workItemSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

}

export const SearchClientName = "ISearchRestClient";

export function getSearchClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISearchRestClient {
    return pageContext.getRestClient<ISearchRestClient>(SearchClientName, options);
}

RestClients.add(SearchClientName, { 
    factory: SearchRestClient,
    options: {
        resourceAreaId: "ea48a0a1-269c-42d8-b8ad-ddc8fcdcf578",
        serviceInstanceType: "00000010-0000-8888-8000-000000000000"
    }
});
